"use client";

import { Bell } from "lucide-react";
import { Button } from "@padi/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@padi/ui/popover";
import { useUnreadCount } from "../_hooks/use-notifications";
import { NotificationList } from "./notification-list";
import { useState } from "react";

export function NotificationBell() {
  const { data: unreadCount = 0 } = useUnreadCount();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative shrink-0 hover:text-primary transition-colors text-[#AEBBD0]"
        >
          <Bell className="size-5" />
          {unreadCount > 0 && (
            <span className="absolute top-1.5 right-1.5 flex size-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full size-2.5 bg-red-500 border-2 border-background"></span>
            </span>
          )}
          <span className="sr-only">Notifications</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[380px] p-0 mr-4 h-[500px] overflow-hidden flex flex-col shadow-xl"
        align="end"
        sideOffset={8}
      >
        <NotificationList onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
